module.exports = __webpack_public_path__ + "img/kind5.5605b254.png";